<script>
    import {store} from '../stores.js';
    import storage from '../storage.js';
    import {navigate} from 'svelte-routing';

    const user = store('credential', 'getAuth');
    const embed = store('embed', '', '{}');
    const year = (new Date()).getFullYear();

    const logout = () => {
        navigate('/');
        user.remove();
        storage.clear();
    };
</script>

<!-- App footer -->
{#if !$embed.footer}
    <div class="appFooter">
        <div class="d-flex justify-content-around text-center">
            <div>
                {#if $user.id > 0}<div on:click={logout}>{$user.name} {$user.email} [{$user.id}]</div>{/if}
                <div>v{APP_VERSION} [type: {APP_TYPE}] (build: {COMMIT_SHA})</div>
                <div>Copyright © {year} <a href="https://u4et.ru" target="_blank">u4et.ru</a></div>
            </div>
        </div>
    </div>
{/if}
<!-- * App footer -->
